import type { ReactNode } from 'react'
import React from 'react'

import * as S from './FixedRatesTableColumn.styled'

type FixedRatesTableColumnProps = {
  title: string
  subtitle: string
  inputs: ReactNode[]
}

export const FixedRatesTableColumn = ({ title, subtitle, inputs }: FixedRatesTableColumnProps) => {
  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      <S.Subtitle>{subtitle}</S.Subtitle>
      {inputs.map((input, index) => (
        <S.Input key={index}>{input}</S.Input>
      ))}
    </S.Container>
  )
}
